<template>
  <div class="gray-block">
    <slot></slot>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.gray-block {
  background-color: #f2f4f8;
  padding: 20px;
  border-radius: 4px;
}
</style>
